import { MaxContainerDimensions } from "shared/lib/breakpoints/useBreakpoints"

export enum HorizontalBreakpoint {
  MOBILE = "mobile",
  MOBILE_LANDSCAPE = "mobile-landscape",
  TABLET = "tablet",
  LAPTOP = "laptop",
  DESKTOP = "desktop",
  WIDE = "wide",
  ULTRA_WIDE = "ultra-wide"
}

export const DEFAULT_BREAKPOINTS: Record<
  HorizontalBreakpoint,
  MaxContainerDimensions
> = {
  [HorizontalBreakpoint.MOBILE]: { maxWidth: 36 },
  [HorizontalBreakpoint.MOBILE_LANDSCAPE]: { maxWidth: 48 },
  [HorizontalBreakpoint.TABLET]: { maxWidth: 62 },
  [HorizontalBreakpoint.LAPTOP]: { maxWidth: 75 },
  [HorizontalBreakpoint.DESKTOP]: { maxWidth: 90 },
  [HorizontalBreakpoint.WIDE]: { maxWidth: 108 },
  [HorizontalBreakpoint.ULTRA_WIDE]: { maxWidth: 120 }
}

export const DEFAULT_BREAKPOINT_ORDER = [
  HorizontalBreakpoint.MOBILE,
  HorizontalBreakpoint.MOBILE_LANDSCAPE,
  HorizontalBreakpoint.TABLET,
  HorizontalBreakpoint.LAPTOP,
  HorizontalBreakpoint.DESKTOP,
  HorizontalBreakpoint.WIDE,
  HorizontalBreakpoint.ULTRA_WIDE
]

export const getValueForBreakpoint = <T>(
  activeBreakpoints: Record<HorizontalBreakpoint, boolean>,
  valuesByBreakpoint: Partial<Record<HorizontalBreakpoint, T>>
): T | undefined => {
  for (let i = 0; i < DEFAULT_BREAKPOINT_ORDER.length; i += 1) {
    const bp = DEFAULT_BREAKPOINT_ORDER[i]
    if (activeBreakpoints[bp] && valuesByBreakpoint[bp] !== undefined) {
      return valuesByBreakpoint[bp]
    }
  }
  return undefined
}

export const PORTFOLIO_COLUMNS_BY_BREAKPOINT: Partial<
  Record<HorizontalBreakpoint, number>
> = {
  [HorizontalBreakpoint.MOBILE_LANDSCAPE]: 1,
  [HorizontalBreakpoint.TABLET]: 2,
  [HorizontalBreakpoint.LAPTOP]: 3,
  [HorizontalBreakpoint.DESKTOP]: 4,
  [HorizontalBreakpoint.ULTRA_WIDE]: 5
}

export const PROJECTS_OVERVIEW_COLUMNS_BY_BREAKPOINT: Partial<
  Record<HorizontalBreakpoint, number>
> = {
  [HorizontalBreakpoint.TABLET]: 1,
  [HorizontalBreakpoint.ULTRA_WIDE]: 2
}

export const BUILDING_REFERENCE_COLUMNS_BY_BREAKPOINT: Partial<
  Record<HorizontalBreakpoint, number>
> = {
  [HorizontalBreakpoint.MOBILE_LANDSCAPE]: 1,
  [HorizontalBreakpoint.TABLET]: 2,
  [HorizontalBreakpoint.LAPTOP]: 3,
  [HorizontalBreakpoint.DESKTOP]: 4,
  [HorizontalBreakpoint.WIDE]: 5,
  [HorizontalBreakpoint.ULTRA_WIDE]: 5
}
